<template>
  <section class="resume-section" id="awards">
    <div class="resume-section-content">
      <h2 class="mb-5">Awards & Certifications</h2>
      <ul class="fa-ul mb-0" v-if="awards.isLoading">
        <BulletListLoader />
      </ul>

      <ul class="fa-ul mb-0" v-else>
        <li v-for="award in awards" :key="award.id">
          <span class="fa-li"><i class="fas fa-trophy text-warning"></i></span>
          {{ award.name }}
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BulletListLoader } from "vue-content-loader";

export default {
  components: { BulletListLoader },
  computed: mapGetters(["awards"]),
  methods: mapActions(["fetchAwards"]),
  created() {
    this.fetchAwards();
  },
};
</script>
